import React from "react";
import ReactDOM from "react-dom/client";
import Demos from "./common/Index.jsx";
import { EemDataProvider } from "./context/EemDataContext";
import "wx-react-gantt/dist/gantt.css";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Create a wrapper div for the main app
const appContainer = document.createElement('div');
appContainer.id = 'app-root';
document.body.appendChild(appContainer);

const root = ReactDOM.createRoot(appContainer);
root.render(
  <EemDataProvider>
    <Demos />
    <ToastContainer
      position="top-right"
      autoClose={3000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
    />
  </EemDataProvider>
);
